module.exports = __webpack_public_path__ + "media/2.2_tabla_10_cf1.2ee6ac57.wav";